/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MovementsReportDto } from '../../models/movements-report-dto';

export interface StockReportsControllerGetMovements$Params {

/**
 * Start date (ISO string)
 */
  dateFrom: string;

/**
 * End date (ISO string)
 */
  dateTo: string;
}

export function stockReportsControllerGetMovements(http: HttpClient, rootUrl: string, params: StockReportsControllerGetMovements$Params, context?: HttpContext): Observable<StrictHttpResponse<MovementsReportDto>> {
  const rb = new RequestBuilder(rootUrl, stockReportsControllerGetMovements.PATH, 'get');
  if (params) {
    rb.query('dateFrom', params.dateFrom, {});
    rb.query('dateTo', params.dateTo, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MovementsReportDto>;
    })
  );
}

stockReportsControllerGetMovements.PATH = '/stock/reports/movements';
